import { clickCertificate, sendElastic } from 'actionCreators/judasLog';

class RegisterElasticCertificateEvent {
  private courseHash: string;
  private progress: number;
  private url: string;
  private title: string;

  constructor(courseHash: string, progress: number, url: string, title: string) {
    this.courseHash = courseHash;
    this.progress = progress;
    this.url = url;
    this.title = title;
  }

  emit = () => {
    clickCertificate({
      hash: this.courseHash,
      progress: this.progress,
      version: this.url.includes('certificados.nutror') ? 'v3' : 'v2',
    })();

    sendElastic('viewCertificate', `Visualizou o certificado do curso ${this.title}`, {
      courseHash: this.courseHash,
    });
    window.open(this.url, '_newtab');
  };
}

export default RegisterElasticCertificateEvent;
